import BookingPage from "../components/pages/BookingPage.vue";
import HomePage from "../components/pages/HomePage.vue";
import LoginPage from "../components/pages/LoginPage.vue";
import LargeCabin from "../components/pages/LargeCabin.vue";
import SmallCabin from "../components/pages/SmallCabin.vue";
import AdminPage from "../components/pages/AdminPage.vue";
import UserEditPage from "../components/pages/UserEditPage.vue";
import BookingEditPage from "../components/pages/BookingEditPage.vue";
import PriceEditPage from "../components/pages/PriceEditPage.vue";
import ProfilePage from "../components/pages/ProfilePage.vue";
import RegisterPage from "../components/pages/RegisterPage.vue";
import ResetPasswordPage from "../components/pages/ResetPasswordPage.vue";
//import NotesPage from "../components/pages/NotesPage.vue";
import NotFoundPage from "../components/pages/NotFoundPage.vue";
import BookingConfirmationPage from "../components/pages/BookingConfirmationPage.vue";
import CheckAvailabilityListPage from "../components/pages/CheckAvailabilityListPage.vue";

const routes = [{
    path: "/",
    component: HomePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    name: "login",
    path: "/login",
    component: LoginPage
  },
  {
    path: "/large-cabin",
    component: LargeCabin
  },
  {
    path: "/small-cabin",
    component: SmallCabin
  },
  {
    path: "/book",
    component: BookingPage
  },
  {
    path: "/admin/:tab",
    component: AdminPage
  },
  {
    path: "/admin",
    component: AdminPage
  },
  {
    path: "/user/:user_id",
    component: UserEditPage
  },
  {
    path: "/booking/:booking_id",
    component: BookingEditPage
  },
  {
    path: "/cabin-price/:price_id",
    component: PriceEditPage
  },
  {
    path: "/cabin-price/",
    component: PriceEditPage
  },
  {
    path: "/profile/",
    component: ProfilePage
  },
  {
    path: "/register/",
    component: RegisterPage
  },
  {
    path: "/reset-password/",
    component: ResetPasswordPage
  },
  /*{
    path: "/notes/",
    component: NotesPage
  },*/
  {
    path: "*",
    component: HomePage 
  },
  {
    path: "/404/",
    component: NotFoundPage 
  },
  {
    path: "/booking-confirmation",
    component: BookingConfirmationPage
  },
  {
    path: "/available-cabin-list",
    component: CheckAvailabilityListPage
  },
];

export default routes;